define("shared/utils/formatters/tiktok-post-from-dynamo", ["exports", "@ember/utils", "later/models/tiktok-post"], function (_exports, _utils, _tiktokPost) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils",0,"later/models/tiktok-post"eaimeta@70e063a35619d71f
  /**
   * Converts a raw dynamo post into an TiktokPost
   *
   * @method createTiktokPostFromDynamo
   * @param {RawDynamoTiktokPost} obj Raw dynamo post
   * @param {SocialProfileModel} socialProfile The social profile for the post
   *
   * @returns {FormattedDynamoTiktokPost} Returns a FormattedDynamoTiktokPost
   */
  const createTiktokPostFromDynamo = (obj, socialProfile) => {
    const attrs = {};
    attrs.timeCollected = Date.now();
    attrs.hasMedia = true;
    attrs.socialProfile = socialProfile;
    attrs.id = obj.id;
    attrs.businessId = obj.business_id;
    attrs.mediaId = obj.media_id;
    attrs.createdTime = Number(obj.created_time);
    attrs.type = 'video';
    attrs.isCarousel = obj.type === 'carousel';
    attrs.isDeleted = obj.is_deleted;
    attrs.thumbUrl = (0, _utils.isPresent)(obj.permanent_image_url) ? obj.permanent_image_url : obj.thumbnail_url;
    attrs.imageUrl = (0, _utils.isPresent)(obj.permanent_image_url) ? obj.permanent_image_url : obj.thumbnail_url;
    attrs.embedUrl = obj.embed_url;
    const engagement = obj.engagement_rate;
    attrs.engagement = (0, _utils.isPresent)(engagement) ? Number(engagement) : engagement;
    const reach = obj.carousel_album_reach || obj.reach;
    attrs.reach = (0, _utils.isPresent)(reach) ? Number(reach) : reach;
    const shareCount = obj.shares;
    attrs.shareCount = (0, _utils.isPresent)(shareCount) ? Number(shareCount) : shareCount;
    const videoViews = obj.carousel_album_video_views || obj.video_views;
    attrs.videoViews = (0, _utils.isPresent)(videoViews) ? Number(videoViews) : videoViews;
    attrs.videoDuration = obj.video_duration;
    attrs.fullVideoWatchedRate = obj.full_video_watched_rate ? Number(obj.full_video_watched_rate) : obj.full_video_watched_rate;
    attrs.caption = obj.caption;
    attrs.averageTimeWatched = obj.average_time_watched;
    attrs.totalTimeWatched = obj.total_time_watched;
    if (!(0, _utils.isNone)(obj.impression_sources)) {
      attrs.impressionSources = [];
      Object.entries(obj.impression_sources || {}).forEach(_ref => {
        let [impression_source, percentage] = _ref;
        attrs.impressionSources.push({
          impressionSource: impression_source,
          percentage: Number(percentage)
        });
      });
    }
    if (!(0, _utils.isNone)(obj.audience_country)) {
      attrs.audienceCountry = [];
      Object.entries(obj.audience_country || {}).forEach(_ref2 => {
        let [country, percentage] = _ref2;
        attrs.audienceCountry.push({
          country,
          percentage: Number(percentage)
        });
      });
    }
    if (!(0, _utils.isNone)(obj.comments)) {
      attrs.commentCount = Number(obj.comments);
    }
    if (!(0, _utils.isNone)(obj.likes)) {
      attrs.likeCount = Number(obj.likes);
    }
    return new _tiktokPost.default(attrs);
  };
  var _default = _exports.default = createTiktokPostFromDynamo;
});